import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

interface Props {
  /** Family codes the server flagged as still-incomplete after the expand. */
  familyCodes: number[];
  onClose: () => void;
}

/**
 * Follow-up modal after `add-by-family` returns a non-empty
 * `incompleteFamilies` list. Mirrors the legacy `showMeTheFamily` panel
 * on `SearchItem.aspx` line 461 / `AddRewardItem.aspx` line 457: the
 * server couldn't add every catalog member of these families (typically
 * inactive items or items the user lacks permission for). We surface
 * the list verbatim so the user can decide what to do next — no
 * additional action is offered because the legacy "Yes" branch is now
 * the same `add-by-family` call we just made.
 */
const IncompleteFamiliesModal = ({ familyCodes, onClose }: Props) => (
  <Dialog title="Incomplete families" width={460} onClose={onClose}>
    <p style={{ marginTop: 0, fontSize: "0.9rem" }}>
      The following famil{familyCodes.length === 1 ? "y was" : "ies were"}{" "}
      added to the deal but{" "}
      <strong>some catalog members could not be inserted</strong>{" "}
      (inactive, restricted, or already on the deal under a different supplier):
    </p>
    <ul
      style={{
        fontSize: "0.85rem",
        margin: "0 0 0.75rem 1rem",
        padding: 0,
        listStyle: "disc",
        color: "#334155",
      }}
    >
      {familyCodes.map((fc) => (
        <li key={fc}>Family {fc}</li>
      ))}
    </ul>
    <p style={{ fontSize: "0.8rem", color: "#64748b", margin: 0 }}>
      To finish adding the missing members, search the catalog by the
      family code and add the remaining items manually.
    </p>
    <DialogActionsBar>
      <Button themeColor="primary" onClick={onClose}>
        OK
      </Button>
    </DialogActionsBar>
  </Dialog>
);

export default IncompleteFamiliesModal;
